import { useState } from "react";
import { Box } from "@mui/material";
import { Alert } from "@mui/material";
import axios from "axios";
import Button from "@mui/material/Button";
import { emailRegex } from "../../utils/regex";

export default function PasswordReset({ handleClose }) {
  const url = process.env.REACT_APP_URL;
  const [email, setEmail] = useState("");
  //Alerts
  const [alert, setAlert] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [disable, setDisable] = useState(false);

  const handleAlert = (message, severity, close = false, duration = 4000) => {
    setMessage(message);
    setSeverity(severity);
    setAlert(true);
    setTimeout(() => {
      setAlert(false);
      setMessage("");
      setSeverity("");
      setDisable(false);
      if (close) {
        handleClose(false);
      }
    }, duration);
  };

  const handlePasswordReset = async () => {
    setDisable(true);
    let reqBody = {
      email: email,
    };
    if (email === "" || !email.match(emailRegex)) {
      handleAlert("Please enter a valid email", "warning");
    } else {
      await axios
        .post(`${url}/login/reset-password`, reqBody)
        .then((res) => {
          handleAlert(
            "New password sent to email provided",
            "success",
            true,
            500
          );
        })
        .catch((err) => {
          handleAlert(`${err.response.data.message}`, "error");
        });
    }
  };

  const enter = (e) => {
    if (e.keyCode === 13) {
      handlePasswordReset();
    }
  };

  return (
    <Box className="password-reset-modal">
      <h2>Password Reset</h2>
      <p>
        Please enter your email. If there is an account attached to this email
        you will receive a new password to login via email. Thank You.
      </p>
      <input
        placeholder="Enter email"
        type="text"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        onKeyDown={(e) => enter(e)}
      />
      <section className="alert-section">
        {alert ? <Alert severity={severity}>{message}</Alert> : null}
      </section>
      <section className="btn-section">
        <Button
          variant="contained"
          color="error"
          onClick={() => handleClose(false)}
          disabled={disable}
        >
          Close
        </Button>
        <Button
          variant="contained"
          onClick={handlePasswordReset}
          disabled={disable}
          color="success"
        >
          Reset
        </Button>
      </section>
    </Box>
  );
}
